import React, {useEffect, useState} from 'react';
import {Dialog} from "primereact/dialog";
import {InputText} from "primereact/inputtext";
import {copyToClipboard, mi} from "../../system/utils";
import {setMessage, setWorkspaceMembership} from "../../system/app-slice";
import Icon from "../../system/components/icon";
import {IconField} from "primereact/iconfield";
import {InputIcon} from "primereact/inputicon";
import {useTranslate} from "../../system/useTranslate";
import {Button} from "primereact/button";
import {useTaskType} from "../../models/task-type/use-task-type";
import {useDispatch, useSelector} from "react-redux";

function TaskTypeDialog({visible, setVisible, taskTypeData, onSubmit}) {
    const {workspaceMembershipData} = useSelector((state) => state.app);
    const [searchText, setSearchText] = useState("");
    const [taskTypeTitle, setTaskTypeTitle] = useState("");
    const [taskTypeIcon, setTaskTypeIcon] = useState("category");
    const translate = useTranslate();
    const taskType = useTaskType();
    const dispatch = useDispatch();

    useEffect(()=>{
       if (visible){
           setTaskTypeTitle(taskTypeData?.title);
           setTaskTypeIcon(taskTypeData?.icon);
       }
    },[taskTypeData])

    const createTaskType = async (taskTypeData)=>{
        if (!taskTypeTitle || !taskTypeIcon){
            dispatch(setMessage({severity:"error", content:translate("task-type-items-error")}))
            return
        }
        taskTypeData = {...taskTypeData, workspace:{connect:[{id:workspaceMembershipData?.workspace.id}]}}
        let _data = await taskType.createTaskType(taskTypeData);
        let _taskTypes = await taskType.getTaskTypes(workspaceMembershipData?.workspace.id);
        dispatch(setWorkspaceMembership({...workspaceMembershipData, workspace: {...workspaceMembershipData.workspace, task_types:_taskTypes}}));
        onSubmit&&onSubmit(_data);
        setVisible(false);
    }

    return (
        <Dialog contentClassName="ltr" header={translate("create-task-type")} className="w-4 h-30rem scrollbar-hide rtl" visible={visible} onHide={()=>{setVisible(false)}}>
            <div className="h-full flex flex-column">
                <div className="p-2 flex align-items-center gap-2 rtl">
                    <span className="border-round border-1 border-300 h-full flex align-items-center justify-content-center pr-1 pl-1">
                        <Icon icon={`mi mi:${taskTypeIcon}`} className="text-5xl"/>
                    </span>
                    <InputText className="w-full" placeholder={translate("task-type-title-placeholder")} value={taskTypeTitle} onChange={(e)=>{setTaskTypeTitle(e.target.value)}}/>
                    <Button className="text-xs h-full pr-3 pl-4" label={translate("create")} onClick={()=>{createTaskType({title:taskTypeTitle, icon:taskTypeIcon})}}/>
                </div>
                <div className="p-2">
                    <IconField dir="rtl">
                        <InputIcon className="pi pi-search"/>
                        <InputText className="w-full" placeholder={translate("search-icons-placeholder")} value={searchText} onChange={(e)=>{setSearchText(e.target.value)}}/>
                    </IconField>
                </div>
                <div className="w-full flex flex-wrap gap-3 justify-content-center overflow-auto mt-2 h-fit">
                    {
                        mi.filter(e=>e.includes(searchText)).map(m=>(<div onClick={()=>{copyToClipboard(`mi mi:${m}`); setTaskTypeIcon(m)}} className="cursor-pointer h-fit flex flex-column"><Icon icon={`mi mi:${m}`} className="text-2xl"/><span className="text-2xs"></span></div>))
                    }
                </div>
            </div>
        </Dialog>
    );
}

export default TaskTypeDialog;